export const movieCollections = [
  { name: "James Bond", id: 645 },
  { name: "The Fast and the Furious", id: 9485 },
  { name: "Toy Story", id: 10194 },
  { name: "The Avengers", id: 86311 },
  { name: "The Lord of the Rings", id: 119 },
  { name: "Die Hard", id: 1570 },
  { name: "Harry Potter", id: 1241 },
  { name: "Guardians of the Galaxy", id: 284433 },
];

